function shouldOpenDialog(trigger) {
    if (!trigger.matches('[data-validate-form-before-dialog]')) {
        return true;
    }

    const form = trigger.closest('form');

    if (!form) {
        return true;
    }

    if (typeof form.reportValidity === 'function') {
        return form.reportValidity();
    }

    if (typeof form.checkValidity === 'function') {
        return form.checkValidity();
    }

    return true;
}

function initPopin() {
    const dialogs = document.querySelectorAll("dialog");
    if (!dialogs.length) return;

    // ------------------------------------
    // Event delegation — clic global
    // ------------------------------------
    document.addEventListener('click', (event) => {

        // Ouvre la dialog
        const openBtn = event.target.closest('.btn-dialog[data-dialog]');

        if (openBtn) {
            event.preventDefault();

            if (!shouldOpenDialog(openBtn)) {
                return;
            }

            const dialogId = openBtn.dataset.dialog;
            const dialog = document.querySelector(`dialog[data-dialog="${dialogId}"]`);
            dialog?.showModal();
            return;
        }

        // Ferme via le bouton "X"
        const closeBtn = event.target.closest('.dialog-close');
        if (closeBtn) {
            event.preventDefault();
            closeBtn.closest('dialog')?.close();
            return;
        }

        // Ferme via le bouton "Confirmer"
        const confirmBtn = event.target.closest('.confirmBtn');
        if (confirmBtn) {
            const dialog = confirmBtn.closest('dialog');
            if (!dialog) return;
            const selectEl = dialog.querySelector('select');
            dialog.close(selectEl?.value ?? '');
            return;
        }

        // Ferme au clic sur le backdrop (clic direct sur <dialog>)
        if (event.target.nodeName === 'DIALOG') {
            event.target.close();
        }
    });

    // ------------------------------------
    // Gestion du returnValue à la fermeture
    // ------------------------------------
    for (const dialog of dialogs) {
        dialog.addEventListener('close', () => {
            const dialogId = dialog.dataset.dialog;
            const outputBox = document.querySelector(`output[data-dialog="${dialogId}"]`);

            if (!outputBox) return;

            outputBox.value =
                (dialog.returnValue === 'default' || dialog.returnValue === '')
                    ? 'Pas de valeur de retour.'
                    : `Valeur de retour : ${dialog.returnValue}.`;
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    initPopin();
});
